module.exports = __webpack_public_path__ + "static/img/logo-ma.8fddb9d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/logo-ma.jpeg
// module id = u3mS
// module chunks = 1